<!--
 * @Author       : dengjianjun
 * @Date         : 2021-12-03 20:07:08
 * @LastEditors  : dengjianjun
 * @LastEditTime : 2021-12-03 21:00:06
 * @Description  : 跳转页面中间页
 * @FilePath     : /fe-estrain-customer/src/pages/jump.mpx
-->

<template>
   <view>index</view>
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from "@/common/jump";

  createPage({
    beforeCreate() {
      mpx.showLoading()
    },
    created() {
      const { redirect } = this.$mpxRoute.query
      innerRouter.replace(redirect)  // @zyt验证
      mpx.hideLoading()
    }
  })
</script>

